<template>
  <span class="prediction-result">
    <template v-if="result"><span v-for="badge in badges" :key="badge.kind" class="result-badge" :class="'result-' + badge.kind">{{ badge.label }}</span></template>
    <span v-else>{{ fallback }}</span>
  </span>
</template>
<script>
export default {
  props: { result: Object, fallback: { type: String, default: '—' } },
  computed: { badges() { return this.result ? [{ kind: 'digit', label: this.result.digit }, { kind: this.result.big_small, label: this.result.big_small === 'big' ? '大' : '小' }, { kind: this.result.odd_even, label: this.result.odd_even === 'odd' ? '单' : '双' }] : [] } }
}
</script>
<style scoped>
.prediction-result { display:inline-flex; align-items:center; gap:4px; vertical-align:middle; white-space:nowrap; }
.result-badge { display:inline-flex; align-items:center; justify-content:center; width:24px; height:24px; border-radius:50%; font-size:13px; line-height:1; flex-shrink:0; color:#fff; }
.result-digit { background:#ead0a0; color:#61451e; }.result-big { background:#ff4d43; }.result-small { background:#00bd87; }.result-odd { background:#8172ff; }.result-even { background:#ff8800; }
</style>
